/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetPluginSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetPluginRequest = {
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetPluginSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetPluginSecurity$outboundSchema: z.ZodMiniType<
  GetPluginSecurity$Outbound,
  GetPluginSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getPluginSecurityToJSON(
  getPluginSecurity: GetPluginSecurity,
): string {
  return JSON.stringify(
    GetPluginSecurity$outboundSchema.parse(getPluginSecurity),
  );
}

/** @internal */
export type GetPluginRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetPluginRequest$outboundSchema: z.ZodMiniType<
  GetPluginRequest$Outbound,
  GetPluginRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getPluginRequestToJSON(
  getPluginRequest: GetPluginRequest,
): string {
  return JSON.stringify(
    GetPluginRequest$outboundSchema.parse(getPluginRequest),
  );
}
